import React, { PureComponent } from 'react';
import { Map, List, fromJS } from 'immutable';
import { injectIntl, defineMessages } from 'react-intl';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as common from 'libs/commonFunc';
import * as templateActions from 'modules/template';

import { PhishingTemplateList } from 'components';

class CtPhishingTemplateList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      fromNowView: false,
      fitRowCount: 0,
      currentPage: 0,
      pageSize: 0,
      searchType: 'searchAll',
      tempFilter: {},
      searchValue: ''
    };
  }

  componentWillMount() {
    // 화면 사이즈(높이)에 해당하는 리스트의 개수 설정
    let fitRowCount = Math.trunc((window.innerHeight - 315) / 48);
    fitRowCount = fitRowCount < 5 ? 5 : fitRowCount;

    this.handleInitFilter();
    this.setState({ pageSize: fitRowCount, fitRowCount });
  }

  componentDidUpdate(prevProps) {
    const { needReload, paramData, examSummary } = this.props;
    if (
      needReload !== prevProps.needReload ||
      // parameter가 변경되었을때
      paramData !== prevProps.paramData ||
      // 훈련 실시했을 때
      examSummary !== prevProps.examSummary
    ) {
      this.getPhishingTemplate();
    }
  }

  // 피싱 템플릿 리스트 조회
  getPhishingTemplate = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true });

      try {
        const { TemplateActions, paramData } = this.props;
        const { currentPage, pageSize } = this.state;
        const params = {
          filter: JSON.stringify(paramData.get('filter')),
          sort: JSON.stringify(paramData.get('sort')),
          offset: pageSize * (currentPage < 0 ? 0 : currentPage), // page 는 0 번 부터 시작
          limit: pageSize < 1 ? 20 : pageSize,
          phishingPage: 1
        };

        await TemplateActions.getPhishingTemplate(params);
      } catch (e) {
        console.log(e);
      }

      this.setState({ loading: false });
    }
  };

  //구분 필터
  isBasicFilter = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['isBasicArray'] === 'undefined') {
      filter['isBasicArray'] = [data.value];
    } else {
      const indexArray = filter['isBasicArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['isBasicArray'].push(data.value);
      } else {
        filter['isBasicArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['isBasicArray'].length === 0 && delete filter['isBasicArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  // 피싱 단계 필터
  phishingLevelFilter = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['phishingLevelArray'] === 'undefined') {
      filter['phishingLevelArray'] = [data.value];
    } else {
      const indexArray = filter['phishingLevelArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['phishingLevelArray'].push(data.value);
      } else {
        filter['phishingLevelArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['phishingLevelArray'].length === 0 && delete filter['phishingLevelArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  // 필터 처리
  // 정렬 처리
  handleFetchData = ({ ...rest }) => {
    const { sorted } = rest;
    const sort = [];
    if (sorted && Array.isArray(sorted)) {
      // 정렬이 적용됨
      for (let i = 0; i < sorted.length; i++) {
        const data = sorted[i];
        sort.push({ field: data.id, order: data.desc ? 'DESC' : 'ASC' });
      }
    }

    const { TemplateActions } = this.props;
    TemplateActions.changePhishingParam({
      name: 'sort',
      value: fromJS(sort)
    });
  };

  // 검색 타입 선택
  handleSearchOptions = (e, { value }) => {
    this.setState({ searchType: value });
  };

  // 검색어 입력
  handleChangeSearch = e => {
    this.setState({ searchText: e.target.value });
  };

  // 검색
  handleOnSearch = e => {
    const { searchValue, searchType, tempFilter } = this.state;
    const { TemplateActions, paramData } = this.props;

    if (
      e.key === 'Enter' ||
      e.target.id === 'bt-search-input' ||
      e.target.parentNode.id === 'bt-search-input' ||
      e.target.parentNode.parentNode.id === 'bt-search-input'
    ) {
      const filter = paramData.get('filter').toJS();
      if (searchValue !== filter[searchType]) {
        // 검색 타입 제거
        const searchOptions = ['searchAll', 'phishingNo', 'serviceNo', 'phishingName'];
        searchOptions.map(option => delete filter[option]);

        if (!!searchValue) {
          filter[searchType] = searchValue;
        }

        this.setState({ currentPage: 0 });
        TemplateActions.changePhishingParam({
          name: 'filter',
          value: fromJS(filter)
        });
      }
    }
  };

  // 체크 취소
  cancelCheck = () => {
    const { TemplateActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    this.setState({
      tempFilter: filter
    });
  };

  // 날짜 필터
  handleChangeDateFilter = (type, data) => {
    const { TemplateActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    if (data.startDate) {
      filter['start' + type] = data.startDate;
    }
    if (data.endDate) {
      filter['end' + type] = data.endDate;
    }

    this.setState({ currentPage: 0 });
    TemplateActions.changePhishingParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 필터 초기화
  handleInitFilter = () => {
    const { TemplateActions } = this.props;

    TemplateActions.changePhishingParam({
      name: 'filter',
      value: Map({})
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
      this.myTextInput.inputRef.value = '';
    }

    this.setState({ searchType: 'searchAll', searchText: '', searchValue: '', tempFilter: {} });
  };

  // 페이지 이동 처리
  handlePagination = pageNo => {
    this.setState({ currentPage: pageNo });
  };

  // 페이지 개수 처리 (페이지 초기화)
  handlePageSizeOnChange = (obj, value) => {
    this.setState({ pageSize: value.value, currentPage: 0 });
  };

  // 검색 입력값 받아오기
  takeSearchValue = value => {
    this.setState({
      searchValue: value
    });
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  //필터 팝업 클로즈
  filterClose = () => {
    const { paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    this.setState({
      tempFilter: filter,
      isLoading: false
    });
  };

  //체크한 필터 실행
  executeFilter = () => {
    const { TemplateActions, paramData } = this.props;
    const { tempFilter, searchType, searchValue } = this.state;
    const filter = tempFilter;

    // 검색 타입 제거
    const searchOptions = ['searchAll', 'phishingNo', 'serviceNo', 'phishingName'];
    searchOptions.map(option => delete filter[option]);
    if (!!searchValue) {
      filter[searchType] = searchValue;
    }

    const paramFilter = paramData.get('filter').toJS();
    if (paramFilter['startRegEpoch']) {
      filter['startRegEpoch'] = paramFilter['startRegEpoch'];
    }
    if (paramFilter['endRegEpoch']) {
      filter['endRegEpoch'] = paramFilter['endRegEpoch'];
    }

    this.setState({ currentPage: 0 });
    TemplateActions.changePhishingParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { loading, fromNowView, currentPage, pageSize, fitRowCount, searchType, searchText, tempFilter } = this.state;
    const { isAuth, templateData, attachData, attachIndexList, totalPages, totalCount, paramData } = this.props;
    const { handleFetchData } = this;
    // 검색
    const {
      handleSearchOptions,
      handleChangeSearch,
      handleOnSearch,
      isBasicFilter,
      phishingLevelFilter,
      handleChangeDateFilter,
      handleInitFilter,
      takeSearchValue,
      searchTextRef,
      cancelCheck,
      filterClose,
      executeFilter
    } = this;
    // 페이징
    const { handlePagination, handlePageSizeOnChange } = this;

    const filterData = paramData.get('filter').toJS();
    let respData = {};
    if (templateData && Map.isMap(templateData)) {
      respData = templateData.toJS();
    }
    if (
      respData &&
      respData.result === 1 &&
      respData.success &&
      Array.isArray(respData.success) &&
      respData.success.length > 0
    ) {
      respData.success.map((tempData, index) => {
        // 사용자 템플릿
        if (tempData.serviceNo) {
          respData.success[index].statistics = 'serviceTemplate';
          // 기본 템플릿
        } else {
          if (tempData.statisticsTarget > 0) {
            respData.success[index].statistics = {
              value:
                defineMessages(
                  formatMessage({
                    id: 'CtPhishingTemplateList_1',
                    defaultMessage: '유출율'
                  })
                ) +
                ': ' +
                (tempData.statisticsInfection / tempData.statisticsTarget * 100).toFixed(0) +
                '% (' +
                tempData.statisticsInfection +
                defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' })) +
                ')',
              detail: (
                <div>
                  <div className="tempPopup-each">
                    <span>
                      {defineMessages(
                        formatMessage({
                          id: 'CtPhishingTemplateList_3',
                          defaultMessage: '누적 훈련 대상'
                        })
                      ) + ': '}
                    </span>
                    <span>
                      {tempData.statisticsTarget +
                        defineMessages(
                          formatMessage({
                            id: 'ExamDetail_45',
                            defaultMessage: '명'
                          })
                        )}
                    </span>
                  </div>
                  <div className="tempPopup-each">
                    <span>
                      {defineMessages(
                        formatMessage({
                          id: 'CtPhishingTemplateList_4',
                          defaultMessage: '누적 발송'
                        })
                      ) + ': '}
                    </span>
                    <span>
                      {tempData.statisticsSend +
                        defineMessages(
                          formatMessage({
                            id: 'ExamDetail_45',
                            defaultMessage: '명'
                          })
                        )}
                    </span>
                  </div>
                  <div className="tempPopup-each">
                    <span>
                      {defineMessages(
                        formatMessage({
                          id: 'CtPhishingTemplateList_5',
                          defaultMessage: '누적 열람'
                        })
                      ) + ': '}
                    </span>
                    <span>
                      {tempData.statisticsRead +
                        defineMessages(
                          formatMessage({
                            id: 'ExamDetail_45',
                            defaultMessage: '명'
                          })
                        )}
                    </span>
                  </div>
                  <div className="tempPopup-each">
                    <span>
                      {defineMessages(
                        formatMessage({
                          id: 'CtPhishingTemplateList_6',
                          defaultMessage: '누적 피싱 접속'
                        })
                      ) + ': '}
                    </span>
                    <span>
                      {tempData.statisticsRead +
                        defineMessages(
                          formatMessage({
                            id: 'ExamDetail_45',
                            defaultMessage: '명'
                          })
                        )}
                    </span>
                  </div>
                  <div className="tempPopup-each">
                    <span>
                      {defineMessages(
                        formatMessage({
                          id: 'CtPhishingTemplateList_8',
                          defaultMessage: '누적 정보 유출'
                        })
                      ) + ': '}
                    </span>
                    <span>
                      {tempData.statisticsInfection +
                        defineMessages(
                          formatMessage({
                            id: 'ExamDetail_45',
                            defaultMessage: '명'
                          })
                        )}
                    </span>
                  </div>
                </div>
              )
            };
          } else {
            // respData.success[index].statistics = '0% (0/0)';
          }
        }
      });
    } else {
      // 응답 데이터 오류
    }

    const pageSizeArray = common.ArraySort(common.ArrayDuplicateRemove([5, 10, 20, 25, 50, 100, fitRowCount]));
    const pageSizeOptions = [];
    pageSizeArray.map(value => {
      pageSizeOptions.push({ text: value, value: value });
    });

    //no, 서비스no, 템플릿명으로 변경 필요
    const searchOptions = [
      {
        key: 0,
        text: defineMessages(formatMessage({ id: 'Faq_1', defaultMessage: '전체' })),
        value: 'searchAll'
      },
      {
        key: 1,
        text: defineMessages(formatMessage({ id: 'PhishingTemplateList_11', defaultMessage: 'No' })),
        value: 'phishingNo'
      },
      {
        key: 2,
        text: defineMessages(formatMessage({ id: 'PhishingTemplateList_12', defaultMessage: '서비스No' })),
        value: 'serviceNo'
      },
      {
        key: 3,
        text: defineMessages(formatMessage({ id: 'PhishingTemplateList_5', defaultMessage: '템플릿명' })),
        value: 'phishingName'
      }
    ];

    return (
      <PhishingTemplateList
        isAuth={isAuth}
        fromNowView={fromNowView}
        manual
        data={respData.success}
        totalCount={totalCount}
        page={currentPage}
        pages={totalPages}
        pageSize={pageSize}
        defaultPageSize={fitRowCount}
        pageSizeOptions={pageSizeOptions}
        loading={loading}
        onFetchData={handleFetchData}
        // 검색 영역
        searchObj={{
          filterData: filterData,
          currentPage: currentPage,
          pageSize: pageSize,
          totalCount: totalCount,
          searchType: searchType,
          searchText: searchText,
          searchOptions: searchOptions,
          handleSearchOptions: handleSearchOptions,
          handleChangeSearch: handleChangeSearch,
          handleOnSearch: handleOnSearch,
          handleInitFilter: handleInitFilter,
          defaultPageSize: fitRowCount,
          pageSizeOptions: pageSizeOptions,
          handlePageSizeOnChange: handlePageSizeOnChange,
          takeSearchValue: takeSearchValue,
          searchTextRef: searchTextRef,
          paramData: paramData,
          tempFilter: tempFilter
        }}
        // 필터
        isBasicFilter={isBasicFilter}
        phishingLevelFilter={phishingLevelFilter}
        cancelCheck={cancelCheck}
        filterClose={filterClose}
        executeFilter={executeFilter}
        handleChangeDateFilter={handleChangeDateFilter}
        // 페이징 처리
        handlePagination={handlePagination}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    templateData: state.template.get('phishingData'),
    needReload: state.template.get('needReload'),
    totalPages: state.template.get('phishingTotalPages'),
    totalCount: state.template.get('phishingTotalCount'),
    paramData: state.template.get('phishingParam'),
    attachData: state.templateAttach.getIn(['data', 'success']),
    attachIndexList: state.templateAttach.get('listIndexByNo'),
    isAuth: state.user.get('isAuth'),
    examSummary: state.examSummary.get('examSummaryOrdering')
  };
};

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtPhishingTemplateList));



// WEBPACK FOOTER //
// ./src/script/containers/phishingTemplate/CtPhishingTemplateList.js